import React, { useState } from 'react';
import { IpaType } from '../../phonemes/ipa';
import { countPhonemeSymbols } from '../../world/countSegments';
import { ipaCombos, miscClicks, miscConsonants, miscVowels } from './ChartSymbols';
import { IpaChart } from './IpaChart';

/** show the number of occurences of the various IPA symbols across languages */
export function IpaFrequencyChart(props: {
  readonly segmentsByLanguage: Record<string, string>;
  /** called when a symbol is clicked on */
  readonly clicked?: (ipa: IpaType) => void;
  /** true if a call to 'clicked' will do something useful */
  readonly canClick?: (ipa: IpaType) => boolean;
}) {
  const [otherSegments] = useState(ipaCombos.concat(miscVowels).concat(miscConsonants).concat(miscClicks));
  const [stuff] = useState(() => countPhonemeSymbols(props.segmentsByLanguage, otherSegments));
  const [total] = useState(Object.getOwnPropertyNames(props.segmentsByLanguage).length);

  const lookup = (ipa: IpaType): string => {
    if (ipa === '•') {
      return ipa;
    }
    const count = stuff.get(ipa);
    const percent = count ? Math.round(100 * count / total) : 0;
    const asText = percent ? percent.toString() + '%'
      : count ? '(' + count?.toString() + ')'
        : '(0)';
    return ipa + ' ' + asText;
  }

  const background = (ipa: IpaType): string | undefined => {
    if (ipa === '•') {
      return undefined;
    }
    const count = stuff.get(ipa);
    const percent = count ? Math.round(100 * count / total) : 0;
    return percent >= 85 ? 'rgb(200,255,200)' :
      percent >= 50 ? 'rgb(255,200,200)' :
        percent >= 20 ? 'rgb(200,200,255)' :
          undefined;
  }

  return <IpaChart lookup={lookup} background={background} br={true} misc={true} clicked={props.clicked} canClick={props.canClick} />
}
